import request from '@/utils/request'


// 查询用户收藏信息列表
export function listUserCollect(query) {
  return request({
    url: '/user/user/collect/list',
    method: 'get',
    params: query
  })
}

// 查询用户收藏信息分页
export function pageUserCollect(query) {
  return request({
    url: '/user/user/collect/page',
    method: 'get',
    params: query
  })
}

// 查询用户收藏信息详细
export function getUserCollect(data) {
  return request({
    url: '/user/user/collect/detail',
    method: 'get',
    params: data
  })
}

// 新增用户收藏信息
export function addUserCollect(data) {
  return request({
    url: '/user/user/collect/add',
    method: 'post',
    data: data
  })
}

// 修改用户收藏信息
export function updateUserCollect(data) {
  return request({
    url: '/user/user/collect/edit',
    method: 'post',
    data: data
  })
}

// 删除用户收藏信息
export function delUserCollect(data) {
  return request({
    url: '/user/user/collect/delete',
    method: 'post',
    data: data
  })
}
